/**
 * Определение tenant slug для приложения.
 *
 * Generic SaaS: НИКАКОЙ зашитой mara-специфики. Slug берётся из поддомена
 * (`mare.lovarthotels.ru` / `mare.lovarthotels.com` → `mare`) через общий
 * парсер `@hsc/tenant` (оба боевых домена .ru и .com поддержаны).
 * Для localhost / превью-окружений slug читается из env `VITE_TENANT_SLUG`.
 */
import { parseTenantSlugFromHost } from '@hsc/tenant';

/** Возвращает slug из env (Vite). Пусто если не задан. */
function envTenantSlug(): string | null {
  // import.meta.env типизирован Vite; используем безопасный доступ.
  const raw = (import.meta.env?.VITE_TENANT_SLUG as string | undefined) ?? '';
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/**
 * Резолвит активный tenant slug.
 *
 * Приоритет:
 *   1. Поддомен любого production-домена (`<slug>.lovarthotels.ru` или `.com`).
 *   2. env `VITE_TENANT_SLUG` (локальная разработка / превью).
 *
 * @param hostname по умолчанию `window.location.hostname`.
 * @returns slug или `null`, если определить невозможно.
 */
export function resolveTenantSlug(
  hostname: string | null = typeof window !== 'undefined' ? window.location.hostname : null,
): string | null {
  if (hostname) {
    const fromHost = parseTenantSlugFromHost(hostname);
    if (fromHost) return fromHost;
  }
  return envTenantSlug();
}
